import api from './api';

const BASE_URL = '/species';

class RemittanceService {
  constructor() {
    this.httpClient = api;
  }

  async create(species) {
    try {
      const response = await (
        await this.httpClient.post(`${BASE_URL}`, species)
      ).data;
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async speciesList() {
    try {
      const response = await (await this.httpClient.get(`${BASE_URL}`)).data;
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new RemittanceService();
